import React, { FC } from 'react';
import { Box, Text, Radio } from '@bechtel/gds';
import { RejectWeldReason, RejectFitupReason } from '@bechtel/types';
import { map } from 'lodash';
import { useField } from 'formik';
import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { ListSelectionStyled } from '@bechtel/client-common';
import { ReasonListProps } from './types';
import { Comment } from '../comment';
import { SendBackReasonMessages } from '~/components/atoms';

export const ReasonList: FC<ReasonListProps> = ({ name, reasonList, showComment, onSelectionChange }) => {
  const { i18n } = useLingui();
  const [field, meta, helpers] = useField(name);
  const { setValue } = helpers;
  return (
    <Box flexDirection={{ sm: 'column' }} data-testid={'side-sheet-reason-list'}>
      {map(reasonList, (reason) => {
        const selected = reason.value === field?.value?.value;
        const onClick = () => {
          setValue(reason);
          if (!onSelectionChange) return;
          onSelectionChange(reason);
        };

        return (
          <ListSelectionStyled key={reason.value} onClick={onClick} data-testid={`reason-list-item-${reason.label}`}>
            <Box mr={{ sm: '450' }}>
              <Radio checked={selected} readOnly />
            </Box>
            <Box flexDirection={{ sm: 'row' }} alignItems={{ sm: 'center' }}>
              {reason?.label && (
                <Text size="400" color="grey.1000">
                  {i18n._(SendBackReasonMessages[reason.label])}
                </Text>
              )}
              {(RejectFitupReason.OTHER_REASON === reason.label || RejectWeldReason.OTHER_REASON === reason.label) && (
                <Box pl={{ sm: '200' }}>
                  <Text size="300" color="grey.600">
                    <Trans>(Comment Required)</Trans>
                  </Text>
                </Box>
              )}
            </Box>
          </ListSelectionStyled>
        );
      })}
      {showComment && <Comment name="reasonComment" />}
    </Box>
  );
};
